import React from 'react'

const Pedagio = ({ width = 24, height = 24, fill = '#FFFFFF', ...props }) => (
  <svg
    data-token-name="pedagio"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>pedágio</title>

    <path
      d="M14.6828334,19.5621587 L14.6828334,13.3967069 C14.6828334,13.1819105 14.7679564,12.9750695 14.9201701,12.8239165 L21.4727858,6.25273819 C21.7896767,5.93717313 22.3041273,5.93452133 22.6218139,6.25273819 C22.9392352,6.56830325 22.9400307,7.08275386 22.6231398,7.40097072 L16.3078608,13.7334864 L16.3078608,19.5621587 L22.045311,19.5621587 C22.4939967,19.5621587 22.8575595,19.9254563 22.8575595,20.3736117 C22.8575595,20.8217671 22.4939967,21.1877165 22.045311,21.1877165 L1.99552687,21.1877165 C1.54684108,21.1877165 1.18301313,20.8217671 1.18301313,20.3736117 C1.18301313,19.9254563 1.54684108,19.5621587 1.99552687,19.5621587 L2.78099217,19.5621587 L2.78099217,5.21588157 C2.78099217,3.8714153 3.87433229,2.77887072 5.21826819,2.77887072 L11.1649459,2.77887072 C12.5086166,2.77887072 13.6022219,3.8714153 13.6022219,5.21588157 L13.6022219,19.5621587 L14.6828334,19.5621587 Z M11.9771945,19.5621587 L11.9771945,5.21588157 C11.9771945,4.76772614 11.6128361,4.40177675 11.1649459,4.40177675 L5.21826819,4.40177675 C4.77037795,4.40177675 4.40575446,4.76772614 4.40575446,5.21588157 L4.40575446,19.5621587 L11.9771945,19.5621587 Z M10.0798264,12.845131 L6.28164289,12.845131 C5.83269193,12.845131 5.46912916,12.4818334 5.46912916,12.033678 C5.46912916,11.5855225 5.83269193,11.2195731 6.28164289,11.2195731 L10.0798264,11.2195731 C10.5285122,11.2195731 10.8923401,11.5855225 10.8923401,12.033678 C10.8923401,12.4818334 10.5285122,12.845131 10.0798264,12.845131 Z"
      id="Fill-4"
      fill={fill}
    />

    <g
      id="pedágio"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <use id="icons-/-veloe-/-pedágio" fill="#24206B" xlinkHref="#path-1" />
    </g>
  </svg>
)

export default Pedagio
